/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventParticipantReminderParams } from './eventParticipantReminderParams';

/**
 * Request model for event participant reminder job
 */
export interface RunEventParticipantReminderJobRequest {
  type: 'event_participant_reminder';
  params: EventParticipantReminderParams;
  allowOverlappingJobs?: boolean;
}
